const { createSlice } = require("@reduxjs/toolkit");
const collectionNameSlice = createSlice({
  name: "collectionName",
  initialState: {
    collectionNameTitle: "",
  },
  reducers: {
    setcollectionName(state, action) {
      const collectionNameTitle = action.payload;
      return (state = {
        collectionNameTitle,
      });
    }
  },
});
export const { setcollectionName } =
  collectionNameSlice.actions;
export default collectionNameSlice.reducer;